import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { FieldTree } from "@angular/forms/signals";
import { TranslocoDirective } from "@jsverse/transloco";
import { SdTargetingFormComponent } from "@m19-board/shared/sd-targeting-form/sd-targeting-form.component";
import {
  SdTargetingFormModel,
  SdTargetingFormModelWithoutIsValid,
} from "@m19-board/shared/sd-targeting-form/sd-targeting-form.types";

@Component({
  selector: "app-sd-create-strategy-targetings",
  imports: [TranslocoDirective, SdTargetingFormComponent],
  template: ` <div class="flex flex-col gap-6 py-8" *transloco="let t">
    <div class="flex flex-col gap-1">
      <h4>{{ t("sd-strategy-creation.targetings") }}</h4>
    </div>
    <app-sd-targeting-form [existingTargeting]="existingTargeting()" (formChange)="onFormChange($event)" />
  </div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SdCreateStrategyTargetingsComponent {
  readonly targetings = input.required<FieldTree<SdTargetingFormModel>>();

  protected readonly existingTargeting = computed<SdTargetingFormModelWithoutIsValid | undefined>(() => ({
    targetingType: this.targetings().targetingType().value(),
    segment: this.targetings().segment().value(),
    audienceExpressionType: this.targetings().audienceExpressionType().value(),
    audienceMatchType: this.targetings().audienceMatchType().value(),
    audienceLookback: this.targetings().audienceLookback().value(),
  }));

  onFormChange(value: SdTargetingFormModel): void {
    this.targetings().targetingType().value.set(value.targetingType);
    this.targetings().segment().value.set(value.segment);
    this.targetings().audienceExpressionType().value.set(value.audienceExpressionType);
    this.targetings().audienceMatchType().value.set(value.audienceMatchType);
    this.targetings().audienceLookback().value.set(value.audienceLookback);
    this.targetings().isValid().value.set(value.isValid);
  }
}
